import _ from 'lodash';
import TextField from '~/component/form/TextField'
import React from 'react';
import styled from 'styled-components';

const SurveyResetContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .days {
    width: 200px;
  }
  .periodTargetCollectionNum {
    width: 160px;
  }
`;

interface SurveyResetProps {
  days?: number;
  periodTargetCollectionNum?: number;
  error?: boolean;
}

export const SurveyReset: React.FC<SurveyResetProps> = (props) => {
  return (
    <SurveyResetContainer>
      <div className="days">
        <TextField {...{
          name: 'reset.days',
          type: 'number',
          value: props.days,
          unit: "日",
          error: props.error,
        }} />
      </div>
      <span>毎に</span>
      <div className="periodTargetCollectionNum">
        <TextField {...{
          name: 'reset.periodTargetCollectionNum',
          type: 'number',
          unit: "件",
          value: props.periodTargetCollectionNum,
          error: props.error,
        }} />
      </div>
      <span>の回収</span>
    </SurveyResetContainer>
  );
};


export default SurveyReset